(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    


    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url).then(response => response.text()).then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;

      const recommendations = html.querySelector('.Related_Products');
      const target = productRecommendationsSection.querySelector('.Related_Products');

      if (recommendations && recommendations.innerHTML.trim().length) {
        target.innerHTML = recommendations.innerHTML;

// remove product recommendations if name has "Navidium" in it
        const productRecommendations = document.querySelectorAll('.Related_Product');
        let i = 0;
        productRecommendations.forEach(productRecommendation => {
          const productName = productRecommendation.querySelector('.Title').textContent;
          if (productName.includes('Navidium')) {
            productRecommendation.remove();
          } else {
            i++;
          }
        });

// remove 4th product if there are more than 3 products shown
        if (i > 3) {
          productRecommendations[3].remove();
        }

        window.dispatchEvent(new CustomEvent('global:align'));
      }
    }).catch(e => {
      console.error(e);
    });
  };

  const productRecommendationsSection = document.querySelector('.Related_Products_Section');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
